module.exports = __webpack_public_path__ + "static/media/iphone.4693c846.png";